import React, { useRef } from 'react'
import { IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'

import _addClass from './ListViewUtils/addClass'
import _removeClass from './ListViewUtils/removeClass'
import _width from './ListViewUtils/width'
import _scrollbarSize from './ListViewUtils/scrollbarSize'
import dates from './ListViewUtils/dates'
import _constants from './ListViewUtils/constants'
import _eventLevels from './ListViewUtils/eventLevels'
import _selection from './ListViewUtils/selection'
import { LinearProgress } from "@mui/material"

function Agenda(_ref, ...rest) {
  var selected = _ref.selected,
      getters = _ref.getters,
      accessors = _ref.accessors,
      localizer = _ref.localizer,
      components = _ref.components,
      length = _ref.length,
      date = _ref.date,
      events = _ref.events;
  const onSelectEvent = _ref.onSelectEvent
  const statusColRef = useRef(null);
  const headerRef = useRef(null);
  const dateColRef = useRef(null);
  const timeColRef = useRef(null);
  const techsColRef = useRef(null);
  const tbodyRef = useRef(null);

  const includeTechnicians = _ref.includeTechnicians;
  const isLoading = _ref.isLoading;

  (0, React.useEffect)(function () {
    _adjustHeader();
  });

  const getCellWidth = cellName => {
    if(includeTechnicians) {
        switch (cellName) {
            case "date":
                return "10%";
            case "time":
                return "10%";
            case "status":
                return "10%";
            case "event":
                return "29%";
            case "techs":
                return "41%";
            default:
                return "";
        }
    } 

    switch (cellName) {
      case 'time':
        return '90px';
      case 'date':
        return '100px';
      case 'status':
        return '90px';
      default:
        return ''
    }
  }

  var renderDay = function renderDay(day, events, dayKey) {
    var Event = components.event,
        AgendaDate = components.date;
    events = events.filter(function (e) {
      return (0, _eventLevels.inRange)(e, dates.startOf(day, 'day'), dates.endOf(day, 'day'), accessors);
    });
    return events.map(function (event, idx) {
      var title = accessors.title(event);
      var end = accessors.end(event);
      var start = accessors.start(event);
      const status = event.status
      const technicians = event.technicians
      var userProps = getters.eventProp(event, start, end, (0, _selection.isSelected)(event, selected));
      var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
      var dateCell = React.createElement("td", {
        className: "rbc-agenda-date-cell",
        rowSpan: idx === 0 ? events.length : 0,
        style: idx === 0 ? {width: getCellWidth('date')} : {display: 'none', width: getCellWidth('date')}
      }, AgendaDate ? React.createElement(AgendaDate, {
        day: day,
        label: dateLabel
      }) : dateLabel)
      return (
        <tr
          key={dayKey + '_' + idx}
          className={userProps.className}
          style={userProps.style}
        >
          {dateCell}
          <td className='rbc-agenda-time-cell' style={{width: getCellWidth('time')}}>{timeRangeLabel(day, event)}</td>
          <td style={{width: getCellWidth('status')}}>{status}</td>
          <td style={{width: getCellWidth('event')}}>
            <>
              <IconButton
                onClick={() => {
                  onSelectEvent(event)
                }}
                style={{
                  width: '15px',
                  height: '15px',
                  padding: 0,
                  paddingLeft: '5px',
                  paddingRight: '15px',
                }}
              >
                <EditIcon />
              </IconButton>
              {Event ? <Event event={event} title={title} /> : title}
            </>
          </td>
          {includeTechnicians && <td style={{width: getCellWidth('techs')}}>{technicians.join(", ")}</td>}
        </tr>
      )
    }, []);
  };

  var timeRangeLabel = function timeRangeLabel(day, event) {
    var labelClass = '',
        TimeComponent = components.time,
        label = localizer.messages.allDay;
    var end = accessors.end(event);
    var start = accessors.start(event);

    if (!accessors.allDay(event)) {
      if (dates.eq(start, end)) {
        label = localizer.format(start, 'agendaTimeFormat');
      } else if (dates.eq(start, end, 'day')) {
        label = localizer.format({
          start: start,
          end: end
        }, 'agendaTimeRangeFormat');
      } else if (dates.eq(day, start, 'day')) {
        label = localizer.format(start, 'agendaTimeFormat');
      } else if (dates.eq(day, end, 'day')) {
        label = localizer.format(end, 'agendaTimeFormat');
      }
    }

    if (dates.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
    if (dates.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
    return React.createElement("span", {
      className: labelClass.trim()
    }, TimeComponent ? React.createElement(TimeComponent, {
      event: event,
      day: day,
      label: label
    }) : label);
  };

  var _adjustHeader = function _adjustHeader() {
    if (!tbodyRef.current) return;
    var header = headerRef.current;
    var firstRow = tbodyRef.current.firstChild;
    if (!firstRow) return;
    var isOverflowing = tbodyRef.current.scrollHeight > tbodyRef.current.clientHeight;


    dateColRef.current.style.width = getCellWidth('date')
    timeColRef.current.style.width = getCellWidth('time')
    statusColRef.current.style.width = getCellWidth('status')

    if (includeTechnicians) {
        techsColRef.current.style.width = getCellWidth('technicians')
    }

    if (isOverflowing) {
      (0, _addClass)(header, 'rbc-header-overflowing');
      header.style.marginRight = (0, _scrollbarSize)() + 'px';
    } else {
      (0, _removeClass)(header, 'rbc-header-overflowing');
    }
  };

  var messages = localizer.messages;
  var end = dates.add(date, length, 'day');
  var range = dates.range(date, end, 'day');
  events = events.filter(function (event) {
    return (0, _eventLevels.inRange)(event, dates.startOf(date, 'day'), dates.endOf(end, 'day'), accessors);
  });
  events.sort(function (a, b) {
    return +accessors.start(a) - +accessors.start(b);
  });
  return (
    <div className='rbc-agenda-view'>
      {events.length !== 0 && !isLoading ? (
          <table className='rbc-agenda-table'>
            <thead ref={headerRef}>
              <tr>
                <th className='rbc-header' ref={dateColRef}>
                  {messages.date}
                </th>
                <th className='rbc-header' ref={timeColRef}>
                  {messages.time}
                </th>
                <th className='rbc-header' ref={statusColRef}>
                  Status
                </th>
                <th className='rbc-header'>{messages.event}</th>
                {includeTechnicians && (
                    <th className='rbc-header' ref={techsColRef}>Techs</th>
                )}
              </tr>
            </thead>
              <tbody ref={tbodyRef} className='rbc-agenda-content'>
                {range.map(function (day, idx) {
                  return renderDay(day, events, idx)
                })}
              </tbody>
          </table>
      ) : (
        <span className='rbc-agenda-empty'>
            {isLoading ? <LinearProgress /> : messages.noEventsInRange}
        </span>
      )}
    </div>
  )
  // return React.createElement(
  //   'div',
  //   {
  //     className: 'rbc-agenda-view',
  //   },
  //   events.length !== 0
  //     ? React.createElement(
  //         React.Fragment,
  //         null,
  //         React.createElement(
  //           'table',
  //           {
  //             ref: headerRef,
  //             className: 'rbc-agenda-table',
  //           },
  //           React.createElement(
  //             'thead',
  //             null,
  //             React.createElement(
  //               'tr',
  //               null,
  //               React.createElement(
  //                 'th',
  //                 {
  //                   className: 'rbc-header',
  //                   ref: dateColRef,
  //                 },
  //                 messages.date
  //               ),
  //               React.createElement(
  //                 'th',
  //                 {
  //                   className: 'rbc-header',
  //                   ref: timeColRef,
  //                 },
  //                 messages.time
  //               ),
  //               React.createElement(
  //                 'th',
  //                 {
  //                   className: 'rbc-header',
  //                 },
  //                 messages.event
  //               )
  //             )
  //           )
  //         ),
  //         React.createElement(
  //           'div',
  //           {
  //             className: 'rbc-agenda-content',
  //             ref: contentRef,
  //           },
  //           React.createElement(
  //             'table',
  //             {
  //               className: 'rbc-agenda-table',
  //             },
  //             React.createElement(
  //               'tbody',
  //               {
  //                 ref: tbodyRef,
  //               },
  //               range.map(function (day, idx) {
  //                 return renderDay(day, events, idx)
  //               })
  //             )
  //           )
  //         )
  //       )
  //     : React.createElement(
  //         'span',
  //         {
  //           className: 'rbc-agenda-empty',
  //         },
  //         messages.noEventsInRange
  //       )
  // )
}

Agenda.defaultProps = {
  length: 30
};

Agenda.range = function (start, _ref2) {
  var _ref2$length = _ref2.length,
      length = _ref2$length === void 0 ? Agenda.defaultProps.length : _ref2$length;
  var end = dates.add(start, length, 'day');
  return {
    start: start,
    end: end
  };
};

Agenda.navigate = function (date, action, _ref3) {
  var _ref3$length = _ref3.length,
      length = _ref3$length === void 0 ? Agenda.defaultProps.length : _ref3$length;

  switch (action) {
    case _constants.navigate.PREVIOUS:
      return dates.add(date, -length, 'day');

    case _constants.navigate.NEXT:
      return dates.add(date, length, 'day');

    default:
      return date;
  }
};

Agenda.title = function (start, _ref4) {
  var _ref4$length = _ref4.length,
      length = _ref4$length === void 0 ? Agenda.defaultProps.length : _ref4$length,
      localizer = _ref4.localizer;
  var end = dates.add(start, length, 'day');
  return localizer.format({
    start: start,
    end: end
  }, 'agendaHeaderFormat');
};

export default Agenda;